import { Editor, Element, Path, Range, Transforms } from 'slate';

import { crossesLayoutItem } from './boundary';

function isBlockElement(editor, node) {
  return Element.isElement(node) === true && Editor.isBlock(editor, node) === true;
}

function findBlockPath(editor, point) {
  return Editor.above(editor, { at: point, match: isBlockElement.bind(null, editor), mode: 'lowest' })[1];
}

function isOnEdgePath(path, edgePath) {
  return Path.equals(path, edgePath) === true || Path.isAncestor(path, edgePath) === true;
}

function isFullyInside(startBlockPath, endBlockPath, node, path) {

  if (Element.isElement(node) === false) {
    return false;
  }

  if (isOnEdgePath(path, startBlockPath) === true || isOnEdgePath(path, endBlockPath) === true) {
    return false;
  }

  return Path.isAfter(path, startBlockPath) === true && Path.isBefore(path, endBlockPath) === true;

}

function collectInsideReferences(editor, range, startBlockPath, endBlockPath) {

  const references = [];
  const match = isFullyInside.bind(null, startBlockPath, endBlockPath);

  for (const [, path] of Editor.nodes(editor, { at: range, match, mode: 'highest' })) {
    references.push(Editor.pathRef(editor, path));
  }

  return references;

}

function deleteText(editor, anchor, focus) {

  if (Range.isCollapsed({ anchor, focus }) === false) {
    Transforms.delete(editor, { at: { anchor, focus } });
  }

}

export function isCrossingSelection(editor) {

  const selection = editor.selection;

  if (selection === null || Range.isCollapsed(selection) === true) {
    return false;
  }

  return crossesLayoutItem(editor, Range.start(selection).path, Range.end(selection).path);

}

// A selection that crosses layout items loses its text and the blocks fully inside it, but its
// first and last blocks are never merged (spec 3.7). The caret ends at the start of the selection.
export function deleteAcrossItems(editor) {

  const range = Editor.unhangRange(editor, editor.selection);
  const start = Range.start(range);
  const end = Range.end(range);
  const startBlockPath = findBlockPath(editor, start);
  const endBlockPath = findBlockPath(editor, end);

  Editor.withoutNormalizing(editor, function deleteSelected() {

    const startReference = Editor.pointRef(editor, start);
    const endReference = Editor.pointRef(editor, end);
    const endBlockReference = Editor.pathRef(editor, endBlockPath);
    const references = collectInsideReferences(editor, range, startBlockPath, endBlockPath);

    for (let index = references.length - 1; index >= 0; index--) {
      Transforms.removeNodes(editor, { at: references[index].unref() });
    }

    deleteText(editor, Editor.start(editor, endBlockReference.unref()), endReference.unref());
    deleteText(editor, startReference.current, Editor.end(editor, startBlockPath));
    Transforms.select(editor, startReference.unref());

  });

}
